export default __webpack_public_path__ + "static/media/jedi.d534cef7.svg";